module.exports = __webpack_public_path__ + "static/deadtree-a6ab90a4ecd2134a99ac532ffa875600.jpg";